<template>
  <div class="file">
    <input type="file" @change="previewFiles" ref="inputFile" :accept="acceptMimes">
    <div class="file__name" v-for="(item, i) in values" :key="i">
      <span class="file__name-icon"></span>
      <span class="file__name-name">{{ item.name }}</span>
      <button type="button" @click.prevent="removeFile(i)" class="file__remove"></button>
    </div>
    <button type="button" class="file__load" @click.prevent="fakeLoad" v-bind:class="{ btn_disabled: fileCountDisclaimer }">
      <span class="file__load-icon">+</span>
      {{ label }}
    </button>
    <div
      v-if="this.errorSize"
      class="error file__error"
    >
      Файл более 10Мб
    </div>
    <div
      v-if="this.errorType"
      class="error file__error"
    >
      Недопустимый формат файла
    </div>
    <div
      v-if="this.fileCountDisclaimer"
      class="disclaimer file__error"
    >
      Прикреплено максимальное количество файлов
    </div>
  </div>
</template>

<script>
  export default {
    presets: [["@vue/app"]],
    props: {
      name: String,
      label: { type: String, default: 'Прикрепить файл' },
      fileAccept: Array,
      tabindex: {
        type: Number,
        default: 0
      },
      disabled: { type: Boolean, default: false }
    },
    data: () => ({
      searchQuery: null,
      open: false,
      values: [],
      valueName: '',
      duplication: false,
      fileSizeMax: 10485760,
      errorSize: false,
      errorType: false,
      fileCountDisclaimer: false,
      fileCountMax: 5,
    }),
    methods: {
      fakeLoad: function () {
        this.$refs.inputFile.click();
      },
      previewFiles: function (event) {   
        this.errorSize = false;
        this.errorType = false;
        if ( event.target.files[0] === undefined ) return;

        if ( !this.fileAccept.includes(event.target.files[0].type) ) {
            this.errorType = true;
            return;
        }

        if ( event.target.files[0].size > this.fileSizeMax ) {
            this.errorSize = true;
            return;
        }

        this.values.map((item) => {
            item.name === event.target.files[0].name ? this.duplication = true : '';
        });
        if (this.duplication) {
            this.duplication = false;
            return;
        }

        this.values.push({
          name: event.target.files[0].name,
          file: event.target.files[0]
        });

        if(this.values.length === this.fileCountMax){
          this.fileCountDisclaimer = true;
        }

        this.$emit('input', this.values);
      },
      removeFile: function (index) {
        this.values.splice(index, 1);

        if(this.values.length < this.fileCountMax){
          this.fileCountDisclaimer = false;
        }

        this.$emit('input', this.values);
        this.$refs.inputFile.value = "";
      }
    },
    computed: {
      acceptMimes() {
        return this.fileAccept ? this.fileAccept.join(', ') : '';
      }
    },
  };
</script>
<style lang="scss">
@import "../../scss/base/include";
$b: '.file';

#{$b} {
  min-height: 30px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  max-width: calc(100% - 20px);
  input {
    display: none;
  }
  &__load {
    white-space: nowrap;
    border: none;
    background-color: transparent;
    outline: none;
    padding: 0;
    display: flex;
    align-items: center;
    width: 100%;
    font-size: 16px;
    line-height: 30px;
    cursor: pointer;
    &-icon {
      flex: 0 0 auto;
      width: 30px;
      height: 31px;
      border-radius: 10px 2px;
      display: block;
      background: $border2;
      font-weight: 500;
      font-size: 24px;
      line-height: 27px;
      margin-right: 11px;
    }
  }
  &__name {
    flex: 0 0 auto;
    font-size: 16px;
    line-height: 30px;
    display: flex;
    align-items: center;
    max-width: 100%;
    width: 100%;
    margin-bottom: 20px;
    &-icon {
      flex: 0 0 auto;
      display: block;
      width: 30px;
      height: 31px;
      border-radius: 10px 2px;
      background-color: $accent;
      background-image: url(/local/templates/pnd/src/assets/i2/checkbox.svg);
      background-position: center;
      background-repeat: no-repeat;
      margin-right: 11px;
    }
    &-name {
      max-width: calc(100% - 69px);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  &__remove {
    width: 8px;
    height: 8px;
    background: transparent center url(/local/templates/pnd/src/assets/i2/close.svg) no-repeat;
    outline: none;
    border: none;
    cursor: pointer;
    margin-left: 10px;
  }
  &__error {
    bottom: -12px;
    display: block !important;
  }
}
.disclaimer{
  margin-top: 12px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
}
.btn_disabled{
  opacity: 0.5;
  pointer-events: none;
}
.file__load {
    color: black;
}
</style>
